var map = {
  "./shape-square-aquamarine-gradient.png": "91779",
  "./shape-square-aquamarine-light.png": "39200",
  "./shape-square-aquamarine.png": "66588",
  "./shape-square-blue-gradient.png": "22460",
  "./shape-square-blue-light.png": "89485",
  "./shape-square-blue.png": "90785",
  "./shape-square-cyan-gradient.png": "69083",
  "./shape-square-cyan-light.png": "56819",
  "./shape-square-cyan.png": "11040",
  "./shape-square-green-gradient.png": "8766",
  "./shape-square-green-light.png": "60212",
  "./shape-square-green.png": "9618",
  "./shape-square-grey100.png": "51561",
  "./shape-square-grey1000.png": "80578",
  "./shape-square-grey200.png": "92854",
  "./shape-square-grey25.png": "52431",
  "./shape-square-grey300.png": "3850",
  "./shape-square-grey400.png": "32741",
  "./shape-square-grey50.png": "27758",
  "./shape-square-grey500.png": "85606",
  "./shape-square-grey600.png": "57853",
  "./shape-square-grey700.png": "10274",
  "./shape-square-grey800.png": "78973",
  "./shape-square-grey900.png": "65296",
  "./shape-square-indigo-gradient.png": "30409",
  "./shape-square-indigo-light.png": "1541",
  "./shape-square-indigo.png": "90129",
  "./shape-square-lime-gradient.png": "9940",
  "./shape-square-lime-light.png": "6786",
  "./shape-square-lime.png": "71217",
  "./shape-square-magenta-gradient.png": "69542",
  "./shape-square-magenta-light.png": "28197",
  "./shape-square-magenta.png": "86393",
  "./shape-square-navy-gradient.png": "84245",
  "./shape-square-navy-light.png": "88506",
  "./shape-square-navy.png": "83751",
  "./shape-square-orange-gradient.png": "83517",
  "./shape-square-orange-light.png": "88247",
  "./shape-square-orange.png": "84146",
  "./shape-square-purple-gradient.png": "90955",
  "./shape-square-purple-light.png": "36732",
  "./shape-square-purple.png": "91752",
  "./shape-square-red-gradient.png": "71032",
  "./shape-square-red-light.png": "21350",
  "./shape-square-red.png": "95422",
  "./shape-square-yellow-gradient.png": "58612",
  "./shape-square-yellow-light.png": "77490",
  "./shape-square-yellow.png": "7053"
};


function webpackContext(req) {
  var id = webpackContextResolve(req);
  return __webpack_require__(id);
}
function webpackContextResolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
webpackContext.keys = function webpackContextKeys() {
  return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 52181;
